/* eslint-disable no-debugger */
import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import {
    message,
    Input,
    Button,
    Form,
    Space,
    Tooltip,
    Drawer,
    Card,
    Select,
    Modal
} from "antd";
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import moment from "moment";

import {
    deleteAction,
    getPagingAction,
    insertAction,
    updateAction,
} from "../../../helpers/helper";
import { actionGroup } from "../../../helpers/common";
import DataTable from "../../../Components/Common/DataTable";
const { confirm } = Modal;
const Actions = () => {
    document.title = "Management Actions";

    const [form] = Form.useForm();
    const [formSearch] = Form.useForm();
    const [listAction, setListAction] = useState([]);
    const [visibleForm, setVisibleForm] = useState(false);
    const [drawerTitle, setDrawerTitle] = useState("");

    //pagination
    const [totalPage, setTotalPage] = useState(1);
    const [indexPage, setPageIndex] = useState(1);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(10);

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
    const getAllData = async (_prams, indexPage) => {
        try {
            const params = _prams
                ? _prams
                : {
                    pageIndex: indexPage,
                    pageSize: pageSize,
                    search: "",
                };

            const dataRes = await getPagingAction(params);
            setTotalPage(dataRes?.totalPages);

            const data =
                dataRes?.data &&
                dataRes?.data.length > 0 &&
                dataRes?.data.map((item) => {
                    return {
                        key: item._id,
                        actionName: item.actionName,
                        actionLabel: item.actionLabel,
                        actionGroup: item.actionGroup,
                        createdTime: moment(new Date(item.createdTime)).format("DD/MM/YYYY"),
                    };
                });
            return dataRes?.data ? data : [];
        } catch (error) {
            message.error('Bạn không có quyền xem tất cả danh sách hoạt động!');
            setTotalPage(0);
            return [];
        }
    };

    useEffect(() => {
        setLoading(true);
        async function fetchData() {
            const dataRes = await getAllData(null, indexPage);
            setListAction(dataRes);
            setLoading(false);
        }
        fetchData();
    }, [indexPage]);

    const onFinish = async (data) => {
        try {
            const dataReq = {
                actionName: data.actionName,
                actionLabel: data.actionLabel,
                actionGroup: data.actionGroup,
            };

            if (!data.id) {
                const dataRes = await insertAction(dataReq);
                dataRes.status === 1
                    ? message.success(`Lưu hành động thành công!`)
                    : message.error(`Lưu hành động không thành công!`);
            } else {
                const dataRes = await updateAction(data.id, dataReq);
                dataRes.status === 1
                    ? message.success(`Sửa hành động thành công!`)
                    : message.error(`Sửa hành động không thành công!`);
            }
            form.resetFields();
            formSearch.resetFields();
            handleCloseDrawer();
            handleRefresh();
        } catch (error) {
            message.error('Bạn không có quyền sửa hành động!');
            form.resetFields();
            handleCloseDrawer();
            formSearch.resetFields();
        }
    };

    const handleResetForm = () => {
        form.resetFields();
    };

    const handleRefresh = async () => {
        const _params = {
            pageIndex: 1,
            pageSize: 10,
            search: ""
        }
        const dataRes = await getAllData(_params, indexPage);
        setListAction(dataRes.length > 0 ? dataRes : listAction);
        setPageIndex(1);
        formSearch.resetFields();
    };

    const handleSearch = async () => {
        const dataForm = formSearch.getFieldsValue();
        if(!Object.values(dataForm).some((item) => !!item)) {
            return
        }
        const params = {
            pageIndex: 1,
            pageSize: pageSize,
            search: dataForm.actionName || "",
        };
        const dataRes = await getAllData(params, 1);
        setListAction(dataRes.length > 0 ? dataRes : false);
        setPageIndex(1);
    };

    const onPageChange = (page, page_size) => {
        setPageIndex(page);
        setPageSize(page_size);
        onPageChangeAtSearch(page, page_size);
    };

    const onPageChangeAtSearch = async (indexPage, page_size) => {
        setLoading(true);
        const dataForm = formSearch.getFieldsValue();
        const params = {
            pageIndex: indexPage,
            pageSize: page_size,
            search: dataForm.actionName || "",
        };
        const dataRes = await getAllData(params, indexPage);
        setListAction(dataRes.length > 0 ? dataRes : false);
        setLoading(false);
    };

    const onEdit = (key) => {
        const dataEdit = listAction.filter((item) => item.key === key);
        form.setFieldsValue({
            actionName: dataEdit[0].actionName,
            actionLabel: dataEdit[0].actionLabel,
            actionGroup: dataEdit[0].actionGroup,
            id: dataEdit[0].key,
        });
        setDrawerTitle("Chỉnh sửa hành động");
        showDrawer();
    };

    const onDelete = async (key) => {
        try {
            const dataRes = await deleteAction(key);
            dataRes.status === 1
                ? message.success(`Xóa hành động thành công!`)
                : message.error(`Xóa hành động không thành công!`);

            handleRefresh();
        } catch (error) {
            message.error('Bạn không có quyền xóa hành động!');
        }
    };

    const showModalConfirmDelete = (record) => {
        confirm({
			title: 'Bạn có chắc chắn xóa hành động này?',
			icon: <ExclamationCircleFilled />,
			okText: 'Xóa',
			okType: 'danger',
			cancelText: 'Không',
			onOk() {
				onDelete(record);
			},
			onCancel() { },
		});
    };

    const validateInput = (_, value) => {
        if (!value || value.trim() === "") {
            return Promise.reject();
        }
        return Promise.resolve();
    };

    const columns = [
        {
            title: "Tên hành động",
            dataIndex: "actionName",
        },
        {
            title: "Nhãn hành động",
            dataIndex: "actionLabel",
        },
        {
            title: "Nhóm hành động",
            dataIndex: "",
            render: (_, record) => {
                const item = actionGroup.find(
                    (item) => item.value === record.actionGroup
                );
                const label = item ? item.label : "";
                return <p>{label}</p>;
            },
        },
        {
            title: "Thời gian tạo",
            dataIndex: "createdTime",
        },
        {
            title: "Hành động",
            dataIndex: "",
            render: (_, record) =>
                listAction.length >= 1 ? (
                    <Space>
                        <Tooltip title="Chỉnh sửa">
                            <Button
                                type="primary"
                                shape="circle"
                                icon={<EditOutlined />}
                                size="small"
                                onClick={() => onEdit(record.key)}
                            />
                        </Tooltip>
                        <Tooltip title="Xóa">
                            <Button
                                type="danger"
                                shape="circle"
                                icon={<DeleteOutlined />}
                                size="small"
                                onClick={() => showModalConfirmDelete(record.key)}
                            />
                        </Tooltip>
                    </Space>
                ) : null,
        },
    ];

    const onClose = () => {
        setVisibleForm(false);
    };

    const showDrawer = () => {
        setVisibleForm(true);
    };

    const handleNewAction = () => {
        setDrawerTitle("Thêm hành động");
        showDrawer();
        form.resetFields();
    };

    const handleCloseDrawer = () => {
        setDrawerTitle("");
        setVisibleForm(false);
        form.resetFields();
    };
    const handleDeleteSelectRows = async () => {
        confirm({
            title: `Bạn có chắc chắn xóa ${selectedRowKeys.length} hành động đã chọn?`,
            icon: <ExclamationCircleFilled />,
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Không',
            onOk() {
                OnDeleteSelectRows();
            },
            onCancel() { },
        });
    }

    const OnDeleteSelectRows = async () => {
        try {
            setLoadingDeleteRows(true);
            for (const key of selectedRowKeys) {
                await deleteAction(key);
            }
            handleRefresh();
            setSelectedRowKeys([]);
            message.success(`Xóa hành động thành công.`);
            setLoadingDeleteRows(false);
        } catch (error) {
            message.error('Bạn không có quyền xóa hành động!');
        }
    };
    return (
        <>
            <div className="page-content">

                <Card bordered={false}>
                    <Row>
                        <Col xs={12}>
                            <Form
                                form={formSearch}
                                layout="vertical"
                                onFinish={handleSearch}
                                autoComplete="off"
                            >
                                <Row>
                                    <Col sm={3}>
                                        <Form.Item
                                            name="actionName"
                                            label="Tìm kiếm theo tên hành động:"
                                            rules={[
                                                {
                                                    required: false,
                                                    message: "Vui lòng nhập tên hành động!",
                                                },
                                                {
                                                    type: "string",
                                                    min: 1,
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="Nhập tên hành động"
                                                allowClear={true}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Item className="mt-4">
                                            <Space>
                                                <Button
                                                    type="primary"
                                                    htmlType="button"
                                                    onClick={() => handleSearch()}
                                                >
                                                    Tìm kiếm
                                                </Button>

                                                <Button type="primary" onClick={handleNewAction}>
                                                    Tạo
                                                </Button>

                                                <Button
                                                    type="primary"
                                                    htmlType="button"
                                                    onClick={() => handleRefresh()}
                                                >
                                                    Làm mới
                                                </Button>
                                                <Button
                                                    disabled={selectedRowKeys.length == 0}
                                                    loading={loadingDeleteRows}
                                                    type="danger"
                                                    htmlType="button"
                                                    onClick={() => handleDeleteSelectRows()}
                                                >
                                                    Xóa
                                                </Button>
                                            </Space>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Card>
                <div>
                    <Col>
                        <Drawer
                            title={drawerTitle}
                            placement={"right"}
                            width={"30%"}
                            onClose={onClose}
                            open={visibleForm}
                            bodyStyle={{
                                paddingBottom: 80,
                            }}
                            style={{ marginTop: "70px" }}
                        >
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                autoComplete="off"
                            >
                                <Row>
                                    <Col hidden={true}>
                                        <Form.Item name="id" label="Id">
                                            <Input />
                                        </Form.Item>
                                    </Col>

                                    <Form.Item
                                        name="actionName"
                                        label="Tên hành động"
                                        rules={[
                                            {
                                                required: true,
                                                validator: validateInput,
                                                message: "Vui lòng nhập tên hành động!",
                                            },
                                            {
                                                type: "string",
                                                min: 1,
                                            },
                                        ]}
                                        style={{ marginBottom: "22px" }}
                                    >
                                        <Input
                                            placeholder="Nhập tên hành động"
                                            allowClear={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="actionLabel"
                                        label="Nhãn hành động"
                                        rules={[
                                            {
                                                required: true,
                                                validator: validateInput,
                                                message: "Vui lòng nhập nhãn hành động!",
                                            },
                                            {
                                                type: "string",
                                                min: 1,
                                            },
                                        ]}
                                        style={{ marginBottom: "22px" }}
                                    >
                                        <Input
                                            placeholder="Nhập nhãn hành động"
                                            allowClear={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="actionGroup"
                                        label="Nhóm hành động"
                                        rules={[
                                            {
                                                required: true,
                                                validator: validateInput,
                                                message: "Vui lòng chọn nhóm hành động!",
                                            },
                                            {
                                                type: "string",
                                                min: 1,
                                            },
                                        ]}
                                        style={{ marginBottom: "22px" }}
                                    >
                                        <Select
                                            placeholder="Chọn nhóm hành động"
                                            style={{ width: "100%" }}
                                            options={actionGroup}
                                        />
                                    </Form.Item>
                                </Row>

                                <Form.Item className="mt-3">
                                    <Space>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            Lưu
                                        </Button>
                                        <Button
                                            type="primary"
                                            htmlType="button"
                                            onClick={() => handleResetForm()}
                                        >
                                            Làm mới
                                        </Button>
                                        <Button
                                            type="danger"
                                            onClick={handleCloseDrawer}
                                        >
                                            Đóng
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                        </Drawer>
                    </Col>
                </div>
                <DataTable
                    listData={listAction}
                    pageSize={pageSize}
                    columns={columns}
                    indexPage={indexPage}
                    totalPage={totalPage}
                    onPageChange={onPageChange}
                    loading={loading}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                />

            </div>
        </>
    );
};
export default Actions;
